import { getTenantId } from '../../../packages/neb-api-client/src/utils/api-client-utils';
import { parseDate } from '../../../packages/neb-utils/date-util';
import Debouncer from '../../../packages/neb-utils/debouncer';
import { getLocalSession } from '../../../packages/neb-utils/session';
import { track } from '../../library/userpilot';

import { PREALLOCATE_ACTIONS } from '.';

export const PAYMENT_TRACK_EVENTS = Object.freeze({
  MAKE_PAYMENT_CLICKED: 'Make_PatientPayment_Clicked',
  SELECT_AND_PAY_CONFIRM_CLICKED: 'make_payment_select_and_pay_clicked',
  PAYMENT_PROCESSED: 'Payment_Processed',
});

const PAYMENT_ACTIONS_CODE_MAP = Object.freeze({
  [PREALLOCATE_ACTIONS.allocate]: 'allocate',
  [PREALLOCATE_ACTIONS.allocateAndPay]: 'allocate_and_pay',
  [PREALLOCATE_ACTIONS.makePayment]: 'pay',
});

const MANUAL_CARD_REGEX = /^XXXXXXXXXXXX\d{4}$/;

const trackEventParamsMapper = Object.freeze({
  [PAYMENT_TRACK_EVENTS.MAKE_PAYMENT_CLICKED]: params => ({
    patientId: params.patientId,
    flowSelected: params.flowSelected,
    entryPoint: params.entryPoint,
    encounterId: params.encounterId,
    appointmentId: params.appointmentId,
    locationId: params.locationId,
    localstorage: params.currentLocalStorage,
    sessionId: getLocalSession().accessToken,
    tenantId: getTenantId(),
  }),
  [PAYMENT_TRACK_EVENTS.SELECT_AND_PAY_CONFIRM_CLICKED]: params => ({
    patientId: params.patientId,
    patient_outstanding_count: params.outstandingCount,
    patient_outstanding_amount: params.outstandingAmount,
    patient_selected_count: params.selectedCount,
    patient_selected_amount: params.selectedAmount,
    relationship_relative_count: params.relationshipRelativeCount,
    relationship_selected_charges_count:
      params.relationshipSelectedChargesCount,
    relationship_selected_charges_amount:
      params.relationshipSelectedChargesAmount,
    total_amount_selected: params.totalAmountSelected,
    patient_unallocated_amount_available: params.unallocatedAmountAvailable,
    patient_unallocated_amount_used: params.unallocatedAmountUsed,
    total_due_amount: params.totalDueAmount,
    action: PAYMENT_ACTIONS_CODE_MAP[params.action],
    sessionId: getLocalSession().accessToken,
    tenantId: getTenantId(),
  }),
  [PAYMENT_TRACK_EVENTS.PAYMENT_PROCESSED]: params => ({
    patientId: params.patientId,
    success: params.success,
    failureReason: params.failureReason,
    amount: params.amount,
    transactionDate: params.transactionDate
      ? parseDate(params.transactionDate).toISOString()
      : null,
    providerId: params.providerId,
    locationId: params.locationId,
    paymentType: params.codePayment?.code,
    codePaymentId: params.codePayment?.id,
    encounterId: params.encounterId,
    appointmentId: params.appointmentId,
    paymentMethod: params.paymentMethod,
    processManually: MANUAL_CARD_REGEX.test(params.maskedCardDescription),
    AuthEFT: params.authEFT,
    ledgerNote: params.note,
    sessionId: getLocalSession().accessToken,
    tenantId: getTenantId(),
  }),
});

export const USE_PREALLOCATION_OVERLAY_LOCALSTORAGE_KEY =
  'neb:checkout:usePreallocationOverlay';

export const PREALLOCATE_PAYMENT_FLOWS = {
  PAY_ONLY: 'pay_only',
  SELECT_AND_PAY: 'select_and_pay',
};

export const PREALLOCATE_PAYMENT_ENTRY_POINTS = {
  CHECKIN: 'checkin',
  CHECKOUT: 'checkout',
  LEDGER: 'ledger',
};

export const trackEventTriggerDebouncer = new Debouncer((eventName, params) =>
  track(eventName, trackEventParamsMapper[eventName](params)),
);

export const triggerPaymentTrackEvent = (eventName, params) =>
  trackEventTriggerDebouncer.debounce(eventName, params);
